import _ from 'lodash';
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { usePaginatedQuery, InfiniteScrollComponent, captureException } from '@playbookux/playbook-web-core';
import { PAYMENT_STATUSES } from '../../../core/constants/payments';
import ChangeStatusDialog from '../../components/change-status-dialog';
import PaymentsTable from './custom-table';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';

import {
  LIMIT,
  TESTER_PAYMENTS,
  UPDATE_TESTER_PAYMENT_STATUS,
} from '../../../core/graphql/tester-payment';

import {
  Button,
  Container,
  Error,
  HeaderContainer,
  Loader,
  Text,
} from './styles';

const Payments = () => {
  /** states */
  const initialStatusModal = { open: false, error: null };
  const [statusModal, setStatusModal] = useState(initialStatusModal);
  const [paymentSelected, setPaymentSelected] = useState({});

  /** queries */
  const {
    data = {},
    error,
    fetchMore,
    hasMore,
    loading,
  } = usePaginatedQuery(TESTER_PAYMENTS, {
    variables: {
      limit: LIMIT,
      offset: 0,
    },
  }, { dataField: 'testerPayments' });

  const { testerPayments = [] } = data;

  /** mutations */
  const [updatePaymentStatus, { loading: updatingStatus }] = useMutation(UPDATE_TESTER_PAYMENT_STATUS);

  const handleChangeStatus = async (status) => {
    if (paymentSelected.status === status) return;

    try {
      await updatePaymentStatus({
        variables: {
          testerPaymentId: paymentSelected.id,
          status,
        },
      });

      setPaymentSelected({});
      setStatusModal(initialStatusModal);
    } catch (err) {
      setStatusModal({ ...statusModal, error: err });
      captureException('UPDATE_PAYMENT_STATUS_FAILURE', err);
    }
  };

  // TODO There is a ticket to the #TesterAutomation2 blocking it.
  const handleClick = () => {};

  const handleOpenStatusModal = (payment) => {
    setPaymentSelected(payment);
    setStatusModal({ open: true, error: false });
  };

  const handleCloseStatusModal = () => {
    setPaymentSelected({});
    setStatusModal(initialStatusModal);
  };

  const handleOpenVideo = (projectId, testerId) => {
    window.open(`/projects/${projectId}/videos/${testerId}`, '_blank');
  };

  if (loading) return <Loader data-loader="payment-loader" />;

  if (error) {
    return (
      <Container>
        <Error
          error={error}
          defaultMessage="Error while retrieving Payments"
        />
      </Container>
    );
  }

  const hasPaymentSelected = !_.isEmpty(paymentSelected);

  return (
    <>
      <ChangeStatusDialog
        open={hasPaymentSelected && statusModal.open}
        status={hasPaymentSelected && paymentSelected.status}
        onClose={handleCloseStatusModal}
        onClickSave={handleChangeStatus}
        loading={updatingStatus}
        error={statusModal.error}
        statuses={PAYMENT_STATUSES}
      />

      <Container>
        <HeaderContainer>
          <Text.Title>Payments</Text.Title>
          <Button onClick={handleClick}>Add Payment</Button>
        </HeaderContainer>

        <InfiniteScrollComponent
          useWindow
          hasMore={hasMore}
          onLoadMore={fetchMore}
        >
          <PaymentsTable
            payments={testerPayments}
            onOpenStatusModal={handleOpenStatusModal}
            onOpenVideo={handleOpenVideo}
          />
        </InfiniteScrollComponent>
      </Container>
    </>
  );
};

export default withDashboardSidebar(Payments);
